module.exports = __webpack_public_path__ + "dk.f122bb63137f6d5c9131.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/dk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/dk.svg
// module chunks = styles